async function submitForms(formData, formIds, accountIds) {
  return await Promise.all(
    formIds.map((formId, index) => {
      formData['@account'] = accountIds[index];
      formData['__form_id'] = formId;

      return fetch('https://api.ometria.com/forms/signup/ajax', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: new URLSearchParams(formData),
      });
    })
  );
}

document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.signup-form-container-embed');
  const form = document.getElementById('OmetriaSignup');
  const submitButton = document.getElementById('OmetriaSignupSubmit');
  const formContainer = container.querySelector('.signup-form');
  const thankYouPageContainer = container.querySelector('.signup-form__thank-you');

  form.addEventListener('submit', async function (event) {
    event.preventDefault();

    const formData = new FormData(form);
    const data = {};

    for (const [key, value] of formData.entries()) {
      data[key] = value;
    }

    const checkboxes = document.querySelectorAll('.ometria-form-checkbox');
    const checkedCheckboxes = Array.from(checkboxes).filter((checkbox) => checkbox.checked);

    const formIds = checkedCheckboxes.map((checkbox) =>
      checkbox.getAttribute('data-ometria-form-id')
    );

    const accountIds = checkedCheckboxes.map((checkbox) =>
      checkbox.getAttribute('data-ometria-account-id')
    );

    submitButton.classList.add('loading');

    await submitForms(data, formIds, accountIds);

    submitButton.classList.remove('loading');

    formContainer.classList.add('hidden');
    thankYouPageContainer.classList.remove('hidden');
  });
});
